import React from 'react';

const PixelDino = () => (
  <div className="dino-runner">
    <img className="pixel-dino-image" src="/pixel-dinosaur-cutout.png" alt="A teal pixel dinosaur facing right" draggable="false" />
  </div>
);

export default PixelDino;
